import React, {Component} from 'react';
import PropTypes from 'prop-types';
import { withStyles,styled  } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';

import PasswordInput from '../components/PasswordInput';
import COLORS from '../resources/colors/ColorsApp';
import Loader from '../components/Loader';
import {isEmpty, isMail} from '../../config/helpers/Validations';
import DeleteIcon from '@material-ui/icons/Delete';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import KeyboardVoiceIcon from '@material-ui/icons/KeyboardVoice';
import SendIcon from '@material-ui/icons/SendRounded';
import AddIcon from '@material-ui/icons/Add';
import InputBase from '@material-ui/core/InputBase';
import Font, { Text } from 'react-font'
import {Modal} from 'react-bootstrap';
import { Container, Grid, Typography, TextField, Button, Checkbox, FormControlLabel, Paper, Link, Box, CssBaseline } from '@material-ui/core';
import './DatosPersona.css';
const styles = (theme) => ({
  root: {
    height: '50vh',
    
  },
  image: {
    backgroundImage: 'url(https://www.tepic.gob.mx/assets/tepic_parallax.jpg)',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  paper: {
    margin: theme.spacing(8, 4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: theme.spacing(4),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  centeredImage: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    display: 'block',
    maxWidth: '100%',
    height: 'auto',
    textAlign: 'center',
  },
});

const CssTextField = styled(TextField)({
  "& .MuiInputBase-input":{
    color:'black',width:'100%',
    backgroundColor: '#F2F2F2',
    borderRadius:5
      
  },
  '& label.Mui-focused': {
    color: '#88213a',
  },
  '& .MuiInput-underline:after': {
    borderBottomColor: '#88213a',
     color:'#88213a'
  },
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: 'white',
    
    },
    '&:hover fieldset': {
      borderColor: '#88213a',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#88213a',
    },
  },
});

const CModal = styled(Modal)`
  position: fixed;
  width: 400px;
  z-index: 1040;
  border: 1px solid #e5e5e5;
  background-color: rgba(0, 0, 0, 0.5);
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.5);
  padding: 20px;
`;

const ColorButton = styled(Button)(({ theme }) => ({
  color: 'white',
  borderColor: 'white',
  backgroundColor:'#a02042',
  '&:hover': {
    backgroundColor: '#591325',
    color:'white',
    borderColor: '#00AD1F',
  },
}));



class CardLogin extends Component {

  constructor(props){
    super(props);

    this.afterSubmit = this.afterSubmit.bind(this);
    this.validateForm = this.validateForm.bind(this);
    this.keyPress = this.keyPress.bind(this);

    this.state = {
      email: '',
      password: '',
      errEmail: '',
      errPassword: '',
      loading: false,
      modal:false,
    };
  }
  handleEmailChange = evt => {
    this.setState({ email: evt.target.value });
  };

  handlePasswordChange = evt => {
    this.setState({ password: evt.target.value });
  };
  handleSubmit = () => {
    const { email, password } = this.state;
    alert(`Signed up with email: ${email} password: ${password}`);
  };
  afterSubmit(){
    this.setState({loading: false});
  }

  validateForm(){
    let valid=true, errEmail="", errPassword="";
    if(isEmpty(this.state.email)){
      errEmail = "Campo de Usuario, esta vacío";
      valid=false;
    }

    if(isEmpty(this.state.password)){
      errPassword = "Campo de Contraseña, esta vacío";
      valid=false;
    }
    if(!valid){
      this.setState({errEmail: errEmail, errPassword: errPassword});
    }
    return valid;
  }


  keyPress(e){
    if(e.key == 'Enter'){
    

       e.preventDefault();
       if(this.validateForm()){
         this.setState({loading: true});
         this.props.onSubmit(this.state.email, this.state.password, this.afterSubmit)
       }
    }
 }

  render(){
  const { classes, onSubmit } = this.props;
  const { email, password } = this.state;
  const isEnabled = email.length > 0 && password.length > 0;


  return (
    <Container component="main" maxWidth="md">
       <CssBaseline />
       <Loader loading={this.state.loading}/>
        <Grid container className={classes.root}>

          <Grid item xs={false} sm={4} md={6} className={classes.image} />
          <Grid item xs={12} sm={8} md={6} component={Paper} elevation={6} square>
            <div className={classes.paper}>
           
            <center>
            <img src={'https://www.tepic.gob.mx/assets/LogoTepic.png'} alt="Logo" className={classes.centeredImage} />
</center><br/>
<center><h4 style={{color:'#A02042',fontWeight:'bolder'}}>CARTILLAS</h4></center>
              <form className={classes.form} onSubmit={this.handleSubmit}>
                <CssTextField
                  id="custom-css-outlined-input"
                  label="Usuario"
                variant="filled"
                color="secondary"
                style={{width: '100%',
          
                  color:'#88213a',}}
                  margin="normal"
      
                  fullWidth
                  InputLabelProps={{
                    style: {
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                      overflow: 'hidden',
                      width: '100%',
                      color: '#88213a'
                    } }}
                  autoComplete="username"
                  autoFocus
                  value={this.state.email}
                  onChange={(event) => this.setState({email: event.target.value})}
                  onKeyDown={this.keyPress}
                />
                <PasswordInput value={this.state.password}
            fullWidth
              onChange={this.handlePasswordChange} 
              disabled={this.state.loading}
              onKeyDown={this.keyPress}
                />
     
                <ColorButton
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  className={classes.submit}
                  disabled={this.state.loading}
                style={{float: 'right',fontWeight: "bold"}}
                onClick={(event)=> {
                  event.preventDefault();
                  if(this.validateForm()){
                    this.setState({loading: true});
                    onSubmit(this.state.email, this.state.password, this.afterSubmit)
                  }
                }}
                >
                  INGRESAR
                </ColorButton>
               
              </form>
            </div>
          </Grid>
        </Grid>
      </Container>

  );
  }
}



CardLogin.propTypes = {
  classes: PropTypes.object.isRequired,
  onSubmit: PropTypes.func
};

export default withStyles(styles)(CardLogin);